import { useEffect } from "react";
import "./App.css";
import CsiList from "./CsiList";
import ReactGA from "react-ga";


function App() {
  useEffect(() => {
    ReactGA.initialize("UA-208849889-1");
    ReactGA.pageview("/csi-utility-landing");
  }, []);



  return (
    <div className="App">
      <CsiList />

    </div>
  );
}

export default App;
